import { render, staticRenderFns } from "./Vallenorte.vue?vue&type=template&id=4e65fe85"
import script from "./Vallenorte.vue?vue&type=script&lang=js"
export * from "./Vallenorte.vue?vue&type=script&lang=js"
import style0 from "./Vallenorte.vue?vue&type=style&index=0&id=4e65fe85&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports